import React from 'react';

var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.49 7c-.27 0-.49.238-.49.53v11.94c0 .292.22.53.49.53h13.02c.27 0 .49-.238.49-.53V7.53c0-.292-.22-.53-.49-.53H5.49zm0-2h13.02C19.885 5 21 6.184 21 7.646v11.708C21 20.816 19.885 22 18.51 22H5.49C4.115 22 3 20.816 3 19.354V7.646C3 6.184 4.115 5 5.49 5zm4.797 11.27l2.483-4.31H9.5a1 1 0 0 1 0-2h5a1 1 0 0 1 .867 1.5l-3.346 5.81a1 1 0 0 1-1.734-1zM8 3a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V3zm6.54.07a1 1 0 1 1 2 0v5a1 1 0 0 1-2 0v-5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Calendar.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Calendar as icon };
export default iconHandler(Calendar);